export default "__VITE_ASSET__BLsclaCG__"